import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Chip, TextField } from "@mui/material";

const SupportChat = () => {
  const navigate = useNavigate();

  // Mock chat data (replace with API data as needed)
  const [chat, setChat] = useState({
    id: "CHT-1001",
    subject: "Order delay",
    user: { name: "John Doe", email: "john@example.com" },
    status: "Open" as "Open" | "Under Review" | "Resolved",
    createdAt: "03-Sep-2025 10:30 AM",
    messages: [
      {
        id: 1,
        authorType: "User" as "User" | "Admin",
        authorName: "John Doe",
        text: "Hello, my order seems delayed.",
        time: "03-Sep-2025 10:30 AM",
      },
      {
        id: 2,
        authorType: "Admin" as "User" | "Admin",
        authorName: "Support Agent",
        text: "Hi John, I'm checking this for you.",
        time: "03-Sep-2025 10:32 AM",
      },
    ],
  });

  const [reply, setReply] = useState("");

  const statusColor = (status: string) => {
    if (status === "Resolved") return "success";
    if (status === "Under Review") return "warning";
    return "default";
  };

  const sendReply = () => {
    const text = reply.trim();
    if (!text) return;
    setChat((prev) => ({
      ...prev,
      messages: [
        ...prev.messages,
        {
          id: prev.messages.length + 1,
          authorType: "Admin",
          authorName: "Support Agent",
          text,
          time: new Date().toLocaleString(),
        },
      ],
    }));
    setReply("");
  };

  return (
    <>
      <div className="main_title">
        <h1>Chat Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/customer-supports")}> Manage Customer Support </button> -
          Chat Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <div className="left_s">
            <h2>Chat Information</h2>
          </div>
          <div className="right_s">
            <Chip size="small" label={chat.status} color={statusColor(chat.status) as any} />
          </div>
        </div>

        <div className="gap_p">
          <div className="w_33">
            <h6>Chat ID</h6>
            <p>{chat.id}</p>
          </div>
          <div className="w_33">
            <h6>Subject</h6>
            <p>{chat.subject}</p>
          </div>
          <div className="w_33">
            <h6>User</h6>
            <p>
              <b>{chat.user.name}</b>
              <br />
              <span>{chat.user.email}</span>
            </p>
          </div>
          <div className="w_33">
            <h6>Created</h6>
            <p>{chat.createdAt}</p>
          </div>
        </div>
      </div>

      <div className="cards mt_20">
        <div className="table_header">
          <div className="left_s">
            <h2>Conversation</h2>
          </div>
        </div>

        <div className="conversation_list" style={{ padding: 16 }}>
          {chat.messages.map((m) => (
            <div key={m.id} className={`conversation_item ${m.authorType === "Admin" ? "is_admin" : ""}`} style={{ marginBottom: 12 }}>
              <div className="user_block">
                <figure>
                  <img src="/static/images/user_placeholder.png" alt="User" />
                </figure>
                <p>
                  <b>{m.authorName}</b>
                  <span>{m.time}</span>
                </p>
              </div>
              <div style={{ marginTop: 6 }}>
                <p>{m.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="reply_box" style={{ padding: 16, borderTop: "1px solid #eee" }}>
          <Box sx={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
            <TextField
              fullWidth
              multiline
              minRows={2}
              placeholder="Type your reply..."
              value={reply}
              onChange={(e) => setReply(e.target.value)}
            />
            <Button className="btn btn_primary" onClick={sendReply}>Send</Button>
          </Box>
        </div>
      </div>
    </>
  );
};

export default SupportChat;
